import { render, staticRenderFns } from "./OrbitSatellite.vue?vue&type=template&id=bcf1cbc2&scoped=true&"
import script from "./OrbitSatellite.vue?vue&type=script&lang=js&"
export * from "./OrbitSatellite.vue?vue&type=script&lang=js&"
import style0 from "./OrbitSatellite.vue?vue&type=style&index=0&id=bcf1cbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1cbc2",
  null
  
)

export default component.exports